<template>
  <v-container v-if="loading" style="height: 200px">
    <v-row class="fill-height" align-content="center" justify="center">
      <v-col class="text-subtitle-1 text-center" cols="12">
        データを取得中です
      </v-col>
      <v-col cols="3">
        <v-progress-linear
          color="indigo accent-2"
          indeterminate
          rounded
          height="6"
        ></v-progress-linear>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      required: true
    }
  }
}
</script>

<style scoped></style>
